import React, { useState } from 'react'
import cx from 'classnames'

const CollapsibleCard = ({
  title,
  items,
  className,
  icon,
  link,
  isOpenDefault = false,
  children,
  stripeColor,
  alwaysOpen = false,
}) => {
  const [isOpen, setIsOpen] = useState(alwaysOpen || isOpenDefault)
  const toggle = () => {
    if (alwaysOpen) {
      return
    }

    setIsOpen(!isOpen)
  }

  return (
    <div
      className={cx('CollapsibleCard', className, { isOpen, alwaysOpen })}
      onClick={toggle}
    >
      <div className={`CollapsibleCard__stripe ${stripeColor}`} />
      <div className="CollapsibleCard__body">
        {icon && (
          <div className="CollapsibleCard__icon">
            <img src={icon} alt="" />
          </div>
        )}

        <h3 className="CollapsibleCard__title">{title}</h3>

        {isOpen && !alwaysOpen && (
          <i className="CollapsibleCard__chevron far fa-chevron-down" />
        )}
        {!isOpen && !alwaysOpen && (
          <i className="CollapsibleCard__chevron far fa-chevron-right" />
        )}

        <div className="CollapsibleCard__bottom">
          {items && items.length && (
            <ul className="CollapsibleCard__list">
              {items.map((item, idx) => (
                <li className="CollapsibleCard__item" key={idx}>
                  <i className="far fa-check" />
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          )}

          {children}

          {link && <div className="CollapsibleCard__link">{link}</div>}
        </div>
      </div>
    </div>
  )
}

export default CollapsibleCard
